export default __webpack_public_path__ + "static/media/40.e8df2eff.svg";